<div class="change-log-card">
  <h3 class="font-18 font-bold title">سجل التغييرات</h3>

  @if (entries.length > 0) {
    @for (entry of entries; track entry.id; let last = $last) {
      <div class="entry-row">
        <span class="dot"></span>
        <div class="entry-text">
          <p class="action">{{ getActionLabel(entry) }}</p>
          <p class="meta">بواسطة <bdi>{{ entry.created_by?.name || '-' }}</bdi> · <bdi>{{ entry.created_at | saudiDateTime }}</bdi></p>
          @if (entry.changes?.length) {
            <p class="changes">{{ entry.changes.join('، ') }}</p>
          }
        </div>
      </div>
      @if (!last) {
        <div class="divider"></div>
      }
    }
  } @else {
    <p class="no-data">لا توجد تغييرات</p>
  }
</div>
